import gql from 'graphql-tag';

export const updateCoachMutation = gql`
  mutation updateCoach($coachId: ID!, $input: CoachInput!) {
    updateCoach(input: $input, coachId: $coachId) {
      coachId
    }
  }
`;
